import React, { useEffect } from 'react';
import Navigation from '../components/Navigation';
import SEOComponent from '../components/SEOComponent';
import SeasonalCapacityNote from '../components/SeasonalCapacityNote';

// "Common sense heat pump sizing" Tally form. Distinct from the waitlist form
// embedded in Contact.js — this is the free sizing tool.
const TallySizingForm = () => {
  useEffect(() => {
    // The embed script is loaded async in public/index.html. If it landed before
    // this iframe mounted it won't have seen it, so kick it manually.
    if (window.Tally) {
      window.Tally.loadEmbeds();
    }
  }, []);

  return (
    <iframe
      data-tally-src="https://tally.so/embed/J9xyPR?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
      loading="lazy"
      width="100%"
      height="400"
      frameBorder="0"
      marginHeight="0"
      marginWidth="0"
      title="Rebel Sensor - common sense heat pump sizing"
      aria-label="Heat pump sizing form"
    ></iframe>
  );
};

const HeatPumpSizing = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sizingSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Free Heat Pump Sizing | Rebel Heat",
    "description": "Free heat pump sizing. We fit a sensor to your gas boiler for two to three weeks and tell you whether your home could run on a heat pump, based on how your boiler behaves in the cold.",
    "url": "https://www.rebelheat.co.uk/heat-pump-sizing"
  };

  return (
    <>
      <SEOComponent
        title="Free Heat Pump Sizing | Rebel Heat"
        description="Free heat pump sizing. We fit a small sensor to your gas boiler for two to three weeks, then tell you whether your home could run on a heat pump, based on how your boiler actually behaves in the cold."
        url="https://www.rebelheat.co.uk/heat-pump-sizing"
        image="https://www.rebelheat.co.uk/church.jpeg"
        schema={sizingSchema}
      />
      <div className="min-h-screen bg-white">
        <Navigation />
        <div id="main-content" className="container-max px-4 py-20">
          {/* CTA */}
          <div className="text-center mb-12">
            <div className="bg-gradient-to-r from-rebel-coral to-rebel-orange rounded-3xl p-12 max-w-4xl mx-auto">
              <p className="text-xs font-bold tracking-widest text-white/80 uppercase mb-4 font-sans" style={{ maxWidth: 'none' }}>
                TRY OUR CUTTING EDGE TECH FOR FREE
              </p>
              {/* The form states the offer itself, so no blurb here — it just repeats. */}
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight">
                Common sense heat pump sizing
              </h1>
              <SeasonalCapacityNote tone="light" className="mt-6" />
            </div>
          </div>

          {/* Form */}
          <div className="max-w-3xl mx-auto">
            <div className="game-card p-8 sm:p-10">
              <TallySizingForm />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeatPumpSizing;
